/**
 * JWC wishlist storage — product handles only (slug strings, not numeric IDs).
 */
(function () {
  const STORAGE_KEY = 'wishlist';

  function normalizeEntry(value) {
    const entry = String(value == null ? '' : value).trim();
    if (!entry) return '';
    // Legacy saves used numeric product IDs; wishlist page fetches by handle.
    if (/^\d+$/.test(entry)) return '';
    return entry;
  }

  function normalizeList(items) {
    if (!Array.isArray(items)) return [];
    const seen = new Set();
    const normalized = [];

    items.forEach((item) => {
      const entry = normalizeEntry(item);
      if (!entry || seen.has(entry)) return;
      seen.add(entry);
      normalized.push(entry);
    });

    return normalized;
  }

  function readWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      return normalizeList(JSON.parse(raw));
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(handles, options) {
    const normalized = normalizeList(handles);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));

    if (!options || !options.silent) {
      window.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: { wishlist: normalized },
        })
      );
    }

    return normalized;
  }

  function isInWishlist(handle) {
    const entry = normalizeEntry(handle);
    if (!entry) return false;
    return readWishlist().includes(entry);
  }

  function toggleWishlist(handle) {
    const entry = normalizeEntry(handle);
    if (!entry) return readWishlist();

    const list = readWishlist();
    const index = list.indexOf(entry);

    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(entry);
    }

    return writeWishlist(list);
  }

  function addToWishlist(handle) {
    const entry = normalizeEntry(handle);
    if (!entry) return readWishlist();

    const list = readWishlist();
    if (!list.includes(entry)) list.push(entry);
    return writeWishlist(list);
  }

  function removeFromWishlist(handle) {
    const entry = normalizeEntry(handle);
    if (!entry) return readWishlist();
    const list = readWishlist();
    return writeWishlist(list.filter((item) => item !== entry));
  }

  // Migrate legacy numeric IDs out of storage on load.
  function migrateStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      const normalized = normalizeList(parsed);
      if (JSON.stringify(parsed) !== JSON.stringify(normalized)) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
      }
    } catch (error) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  migrateStorage();

  window.JwcWishlist = {
    STORAGE_KEY,
    readWishlist,
    writeWishlist,
    isInWishlist,
    toggleWishlist,
    addToWishlist,
    removeFromWishlist,
    normalizeList,
  };
})();
